import { render } from "./Module.vue?vue&type=template&id=4c664edf"
import script from "./Module.vue?vue&type=script&lang=js"
export * from "./Module.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src1910356388/src/ilongevity-backoffice/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__